/**
 * Onboarding Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';

export const onboardingRoutes: RouteRecordRaw[] = [
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('./views/TenantListView.vue'),
    meta: {
      title: 'Tenants',
      breadcrumbs: [{ label: 'Tenants' }],
      modulePermission: 'tenantManagement',
    },
  },
  {
    path: '/onboarding/new',
    name: 'onboarding-new',
    component: () => import('./views/OnboardingView.vue'),
    meta: {
      title: 'New Tenant',
      breadcrumbs: [
        { label: 'Tenants', to: '/onboarding' },
        { label: 'New Tenant' },
      ],
      modulePermission: 'tenantManagement',
    },
  },
];
